// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"666":"5f07691d","950":"2d984776"}[chunkId] + ".chunk.css";
};